import { LinkButton } from '@components/LinkButton/LinkButton'
import Spinner from '@components/Spinner'
import usePractitionerData from '@hooks/usePractitionerData'
import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import AppointmentPractitionerAvatar from '../../AppointmentPractitionerAvatar'
import { ReactComponent as PencilIcon } from 'src/images/icon-pencil.svg'
import useStyles from './AppointmentPractitioner.styles'
import { useTranslation } from 'react-i18next'
import * as styles from './AppointmentPractitioner.styles'
type AppointmentPractitionerProps = {
  hidePractitionerChangeButton?: boolean
}

const AppointmentPractitioner = ({ hidePractitionerChangeButton }: AppointmentPractitionerProps) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const { t } = useTranslation()

  const {
    practitionerDetailsFirstLine,
    practitionerDetailsSecondLine,
    hasRecommendedPractitioner,
    imageUrl,
    isPractitionerDataLoading,
  } = usePractitionerData()
  return (
    <div>
      <Box sx={() => styles.practitionerInfoContainer(hidePractitionerChangeButton)}>
        <AppointmentPractitionerAvatar imageUrl={imageUrl} hasRecommendedPractitioner={hasRecommendedPractitioner} />
        <div>
          {isPractitionerDataLoading ? (
            <Spinner />
          ) : (
            <>
              <Typography variant="Lato Emphasized 2" className={classes.practitionerNameContainer}>
                {practitionerDetailsFirstLine}
              </Typography>
              <Typography variant="Lato Caption">{practitionerDetailsSecondLine}</Typography>
            </>
          )}
        </div>
      </Box>
      {!hidePractitionerChangeButton && (
        <LinkButton className={classes.selectPractitionerButton} onClick={() => history.push(routes.practitioner)}>
          <PencilIcon className={classes.pencilIcon} fill={theme.palette.primary[800]} />
          <Typography variant="Lato Emphasized 1" color={theme.palette.primary.main}>
            {t('select_practitioner')}
          </Typography>
        </LinkButton>
      )}
    </div>
  )
}

export default AppointmentPractitioner
